export enum ICarStockMatch {
  EXACT = 'EXACT',
  NEAR = 'NEAR',
}
